/* eslint-disable react/prop-types */
import React, { useState } from "react";
import MDButton from "components/MDButton";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import ControlledTextInput from "components/FormInputs/ControlledTextInput";
import ControlledCheckbox from "components/FormInputs/ControlledCheckbox";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Controller } from "react-hook-form";
import { TextField, InputAdornment, Select, MenuItem } from "@mui/material";

function CustomProductNode({ control, removeProductNode, index, setValue }) {
  const [discountType, setDiscountType] = useState("%"); // "%" or "$"

  return (
    <MDBox
      sx={{
        border: "1px solid #d2d6da",
        borderRadius: "0.375rem",
        mb: 3,
        pt: 2,
        pl: 1,
        position: "relative",
      }}
      key={index}
    >
      <MDTypography
        component="p"
        sx={{
          fontSize: "0.8rem",
          fontWeight: 500,
          transform: "translate(7px, -50%)",
          backgroundColor: "#fff",
          color: "#7b809a",
          padding: "0 5px",
          position: "absolute",
          left: 0,
          top: 0,
        }}
      >
        Item {index + 1}
      </MDTypography>

      <GridContainer sx={{ mt: 0.5 }}>
        <GridItem xs={12} sm={12} md={11} lg={11} xl={11}>
          <GridContainer>
            {/* Product Name */}
            <GridItem xs={12} sm={12} md={4}>
              <ControlledTextInput
                name={`products.${index}.name`}
                control={control}
                label="Product Name"
                formControlProps={{ fullWidth: true }}
                multiline
              />
            </GridItem>

            {/* SKU */}
            <GridItem xs={12} sm={12} md={4}>
              <ControlledTextInput
                name={`products.${index}.sku`}
                control={control}
                label="SKU *"
                formControlProps={{ fullWidth: true }}
                multiline
              />
            </GridItem>

            {/* Price */}
            <GridItem xs={12} sm={12} md={4}>
              <ControlledTextInput
                name={`products.${index}.price`}
                control={control}
                labelText="Price (Without Tax)*"
                formControlProps={{ fullWidth: true }}
                inputProps={{ type: "number" }}
              />
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <Controller
                name={`products.${index}.discount_${
                  discountType === "%" ? "percentage" : "amount"
                }`}
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    type="number"
                    label="Discount"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ p: 0 }}>
                          <Select
                            value={discountType}
                            onChange={(e) => {
                              setDiscountType(e.target.value);
                              setValue(`products.${index}.discount_amount`, "");
                              setValue(`products.${index}.discount_percentage`, "");
                            }}
                            variant="standard"
                            disableUnderline
                            sx={{
                              "& .MuiSelect-select": {
                                p: "0 4px",
                                minWidth: "32px",
                                textAlign: "center",
                              },
                            }}
                          >
                            <MenuItem value="%">%</MenuItem>
                            <MenuItem value="$">$</MenuItem>
                          </Select>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </GridItem>

            {/* QTY */}
            <GridItem xs={12} sm={12} md={4}>
              <ControlledTextInput
                name={`products.${index}.qty`}
                control={control}
                labelText="QTY *"
                formControlProps={{ fullWidth: true }}
                inputProps={{ type: "number" }}
              />
            </GridItem>

            {/* Digital Good */}
            <GridItem xs={12} sm={12} md={4}>
              <ControlledCheckbox
                name={`products.${index}.is_digital_good`}
                control={control}
                label="Is Digital Good?"
              />
            </GridItem>
          </GridContainer>
        </GridItem>

        {/* Remove Button */}
        <GridItem xs={12} sm={12} md={1}>
          <MDButton
            color="warning"
            variant="gradient"
            iconOnly
            onClick={() => removeProductNode(index)}
          >
            <IndeterminateCheckBoxIcon />
          </MDButton>
        </GridItem>
      </GridContainer>
    </MDBox>
  );
}

export default CustomProductNode;
